export interface BoardStages {

  pending: string[];
  inProgress: string[];
  completed: string[];

}

export const boardStages = (): string[] => {

  type BoardStageKeys = keyof BoardStages;

  return ['pending', 'inProgress', 'completed'] as BoardStageKeys[];
}
